import React from 'react';

import './style.css'

function Footer() {
    return (
        <div className="content-footer">
            <footer>
                <p>&copy; 2020 Rede Social</p>
                <div className="links">
                    <a href="/">Sobre</a>
                    <a href="/">Blog</a>
                    <a href="/">Carreiras</a>
                    <a href="/">Ajuda</a>
                    <a href="/">API</a>
                    <a href="/">Privacidade</a>
                    <a href="/">Termos</a>
                    <a href="/">Hashtags</a>
                    <a href="/">Localizações</a>
                </div>
            </footer>
        </div>
    )
}

export default Footer